import { render, staticRenderFns } from "./WordListInterlinkDirector.vue?vue&type=template&id=bf22d682"
import script from "./WordListInterlinkDirector.vue?vue&type=script&lang=js"
export * from "./WordListInterlinkDirector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LetterLengthBoxLinks: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/WordListInterlinkDirector/LetterLengthBoxLinks.vue').default})
